import SettingRepository from '../../repositories/SettingRepository';

export default {
	namespaced: true,
	state: {
		cw_plugin: false
	},
	mutations: {
		SET_SETTINGS (state, data) {
			for (const key in data) {
				state[key] = data[key];
			}
		}
	},
	actions: {
		fetchSettings ({ commit, getters }) {
			return SettingRepository.getSettings()
				.then(response => {
					commit('SET_SETTINGS', response);

					return response;
				});
		}
	},
	getters: {
		getSetting: (state) => (key) => state[key]
	}
};
